// Comisiones de las OTAs (7-oct-2026): la tarjeta del anuncio con el % que se queda cada
// canal, el IVA de esa comisión y si la ficha de la reserva enseña lo que de verdad llega.
// Panel: components/Gestores/OtaCommissionsPanel.vue
export const otaCommissions = {
  head: {
    title: "عمولات منصات الحجز",
    sub: "ما تقتطعه كل قناة من حجوزاتك. وبهذا تعرض لك بطاقة كل حجز تقديراً للمبلغ الذي يصلك.",
  },
  loading: "جارٍ تحميل العمولات…",
  loadError: {
    title: "تعذّر تحميل العمولات",
    text: "تحقّق من الاتصال وحاول مرة أخرى.",
    retry: "إعادة المحاولة",
  },
  display: {
    title: "سعر حجوزات المنصات في بطاقة الحجز",
    totalLabel: "الإجمالي الذي ترسله المنصة فقط",
    totalDesc: "كما هو الحال حتى الآن: مبلغ الحجز.",
    netLabel: "وأيضاً ما يصلك",
    netDesc: "إلى جانب الإجمالي، تعرض البطاقة العمولة وضريبة القيمة المضافة على العمولة والمبلغ الصافي الذي ستتسلّمه.",
  },
  rates: {
    title: "العمولة والرسوم لكل منصة",
    hint: "أدخل النسبة التي تظهر في لوحة تحكم كل منصة (في Booking: «العمولة والرسوم» ÷ «السعر الإجمالي»). إذا أبلغت القناة بالعمولة الفعلية للحجز، فهي التي تُستخدم.",
    usual: "المعتاد: {pct}%",
    airbnbNote: "تدفع لك Airbnb المبلغ صافياً: عمولتها مخصومة مسبقاً. اتركه فارغاً (0%) ما لم يستقبل اتصالك المبلغ الإجمالي.",
    managedNote: "تُستخدم هذه النسب أيضاً في التسوية مع المالك.",
  },
  vat: {
    title: "ضريبة القيمة المضافة على عمولة المنصة",
    hint: "تفرض Booking ضريبة القيمة المضافة على عمولتها للمنشآت في إسبانيا (21%) وتخصمها من التحويل. أدخل 0 إذا لم تُفرض عليك.",
  },
  errPercent: "يجب أن تكون نسبة بين 0 و100.",
  example: {
    title: "مثال",
    sub: "حجز عبر {channel} بقيمة {total}",
    total: "السعر الإجمالي",
    commission: "عمولة ورسوم {channel} ({pct}%)",
    vat: "ضريبة القيمة المضافة على العمولة ({pct}%)",
    net: "يصلك",
    foot: "هذا تقدير بهذه النسب: قد تحوّل المنصة مبلغاً مختلفاً قليلاً (التقريب، العروض الترويجية، رسوم الدفع). إذا أبلغت القناة بالعمولة الفعلية، تستخدمها البطاقة.",
  },
  footer: {
    save: "حفظ",
    saving: "جارٍ الحفظ…",
    saved: "تم حفظ العمولات",
    unsaved: "تغييرات غير محفوظة",
    fixErrors: "راجع الحقول المحدّدة",
    errSave: "تعذّر حفظ التغييرات. حاول مرة أخرى.",
    errInvalid: "يجب أن تكون عمولة كل منصة نسبة بين 0 و100.",
  },
};
